var map = {
	"./m1.png": 3053,
	"./m10.png": 15941,
	"./m2.png": 31995,
	"./m3.png": 61538,
	"./m4.png": 67301,
	"./m5.png": 42581,
	"./m6.png": 20101,
	"./m7.png": 54624,
	"./m8.png": 47093,
	"./m9.png": 25318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76459;